export default __webpack_public_path__ + "static/wire-a60c4fbe24415c7c29333b7036f1efc0.png";